import create from "zustand";
import { useEffect, useState } from "react";
import { useProgress } from "@react-three/drei";
import { AchievementsState } from "../../types";

export const useAchievementStore = create<AchievementsState>((set) => ({
  isLoadingComplete: false,
  isAchievementVisible: false,
  activeAchievementId: null,
  flatImageRef: null,
  showAchievementDetails: (id) =>
    set(() => ({ isAchievementVisible: true, activeAchievementId: id })),
  hideAchievementDetails: () =>
    set(() => ({ isAchievementVisible: false, activeAchievementId: null })),
  setIsLoadingComplete: () => set(() => ({ isLoadingComplete: true })),
  setFlatImageRef: (ref) => set(() => ({ flatImageRef: ref })),
}));

export function useLoadingProgress() {
  const [thresholdMet, setThresholdMet] = useState(false);
  const { progress } = useProgress();
  const setIsLoadingComplete = useAchievementStore(
    (state) => state.setIsLoadingComplete,
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setThresholdMet(true);
    }, 3000);

    const hideLoadingScreen = thresholdMet && progress === 100;

    if (hideLoadingScreen) {
      setIsLoadingComplete();
    }
    return () => clearTimeout(timer);
  }, [progress, thresholdMet, setIsLoadingComplete]);

  return progress;
}
